import React from 'react';
import { Typography, Alert, Link } from '@one-thd/sui-atomic-components';
import { useSummaryStore } from '@src/stores/summaryStore';
import QRCode from '@src/components/shared/QR/QRCode';
import { getWindow } from '@src/utils/general';
import { REFUND_TIMING_MESSAGE, SORIS_RETURN_SUMMARY } from '@src/constants';
import SummaryStep from './SummaryStep';
export var SorisNextSteps = function () {
    var _a, _b;
    var sorisId = useSummaryStore(function (state) { return state.sorisId; });
    var sorisQRCode = useSummaryStore(function (state) { return state.sorisQRCode; });
    var hostname = ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hostname) || '';
    var imageSrc = "data:image/png;base64,".concat(sorisQRCode);
    return (React.createElement("div", { className: "lg:sui-w-1/2" },
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, { variant: "h3" }, "Your next steps...")),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 1, title: SORIS_RETURN_SUMMARY.STEP_1_TITLE },
                React.createElement(Typography, { variant: "body-base" },
                    SORIS_RETURN_SUMMARY.STEP_1_SUB,
                    React.createElement(Link, { href: "https://".concat(hostname, "/l/"), target: "_blank" }, "Home Depot store"),
                    SORIS_RETURN_SUMMARY.STEP_1_SUB2))),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 2, title: SORIS_RETURN_SUMMARY.STEP_2_TITLE, texts: [SORIS_RETURN_SUMMARY.STEP_2_SUB] })),
        imageSrc && (React.createElement("div", { className: "sui-mb-6 sui-flex sui-justify-center lg:sui-block lg:sui-ml-7" },
            React.createElement(QRCode, { imageSrc: imageSrc, sorisId: sorisId || '' }))),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Alert, { status: "info", size: "large" },
                React.createElement(Typography, { variant: "body-base" }, SORIS_RETURN_SUMMARY.QR_ALERT))),
        React.createElement("div", { className: "sui-mb-9" },
            React.createElement(SummaryStep, { number: 3, title: SORIS_RETURN_SUMMARY.STEP_3_TITLE, texts: [REFUND_TIMING_MESSAGE] }))));
};
